
import React from 'react';
import { Quote } from 'lucide-react';
import { RECOMMENDATIONS } from '../constants';

const Recommendations: React.FC<{ darkMode: boolean }> = ({ darkMode }) => {
  return (
    <div className="py-10">
      <div className="flex flex-col items-center text-center mb-16">
        <div className="flex items-center gap-3 mb-4">
          <Quote className={`text-blue-600 ${darkMode ? 'dark:text-blue-400' : ''}`} />
          <h3 className={`text-3xl font-bold ${darkMode ? 'text-white' : 'text-slate-900'}`}>Recommendations</h3>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {RECOMMENDATIONS.map((rec, idx) => (
          <div key={idx} className={`relative p-8 ${darkMode ? 'bg-slate-900' : 'bg-white'} rounded-3xl border border-slate-200 dark:border-slate-800 shadow-lg`}>
            <div className="absolute -top-6 -right-6 text-slate-100 dark:text-slate-800 z-0">
               <Quote size={80} fill="currentColor" />
            </div>
            <div className="relative z-10">
              <p className={`text-lg italic ${darkMode ? 'text-slate-300' : 'text-slate-600'} mb-8 leading-relaxed`}>
                "{rec.content}"
              </p>
              <div className="flex items-center gap-4">
                <img 
                  src={rec.avatar} 
                  alt={rec.name} 
                  className="w-14 h-14 rounded-full object-cover ring-2 ring-blue-500/20"
                />
                <div>
                  <div className={`font-bold ${darkMode ? 'text-white' : 'text-slate-900'}`}>{rec.name}</div>
                  <div className="text-sm text-blue-600 dark:text-blue-400">{rec.role}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Recommendations;
